import * as React from 'react';
import { Box, Card, CardActions, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { useNavigate } from 'react-router';

const API_URL = import.meta.env.VITE_API_URL;

const formatDate = (d: Date) => {
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};

const getDayName = (d: Date) => {
  return d.toLocaleDateString('uk-UA', { weekday: 'long' });
};

const Welcome = () => {
  const navigate = useNavigate();
  const [adminName, setAdminName] = React.useState('');

  React.useEffect(() => {
    fetch(`${API_URL}/settings`)
      .then((res) => res.json())
      .then((data) => setAdminName(data?.settings?.adminName || ''))
      .catch(() => setAdminName(''));
  }, []);

  const now = new Date();
  const dateText = `Сьогодні ${formatDate(now)}, ${getDayName(now)}`;

  return (
    <Card
      sx={{
        background: (theme) =>
          `linear-gradient(45deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.light} 50%, ${theme.palette.primary.dark} 100%)`,
        color: (theme) => theme.palette.primary.contrastText,
        padding: '20px',
        marginTop: 2,
        marginBottom: '1em',
      }}
    >
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ flex: '1' }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {adminName ? `Доброго дня, ${adminName}!` : ''}
          </Typography>

          <Box sx={{ maxWidth: '40em', my: 2 }}>
            <Typography variant="body1" component="p" gutterBottom>
              {dateText}
            </Typography>
          </Box>

          <CardActions
            sx={{
              padding: { xs: 0, xl: null },
              flexWrap: { xs: 'wrap', xl: null },
              '& a': {
                marginTop: { xs: '1em', xl: null },
                marginLeft: { xs: '0!important', xl: null },
                marginRight: { xs: '1em', xl: null },
              },
            }}
          >
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => navigate('/products/new')}
            >
              Додати продукт
            </Button>

            <Button
              variant="contained"
              startIcon={<StorefrontIcon />}
              onClick={() => navigate('/products')}
            >
              Продукти
            </Button>

            <Button
              variant="contained"
              startIcon={<EditIcon />}
              onClick={() => navigate('/content')}
            >
              Редагувати бота
            </Button>

            <Button
              variant="contained"
              startIcon={<PermMediaIcon />}
              onClick={() => navigate('/media')}
            >
              Медіа бібліотека
            </Button>

            <Button
              variant="contained"
              startIcon={<SmartToyIcon />}
              onClick={() => window.open('https://t.me/vatsak_bot', '_blank')}
            >
              Бот
            </Button>
          </CardActions>
        </Box>

        <Box
          component="a"
          href="https://vatsak.com.ua/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#fff',
            borderRadius: 3,
            p: 2,
            width: 'fit-content',
            textDecoration: 'none',
          }}
        >
          <img src="/vatsak_logo.svg" />
        </Box>
      </Box>
    </Card>
  );
};

export default Welcome;
